module.exports = __webpack_public_path__ + "img/jo5.b567b29d.png";